// extracted by mini-css-extract-plugin
var _1 = "modal_cancel_button__aD4XZ";
var _2 = "modal_modal_method__b7uTK";
var _3 = "modal_modal_method_centered__wuTbS";
var _4 = "modal_ok_button__f3qgr";
var _5 = "1100";
export { _1 as "cancel_button", _2 as "modal_method", _3 as "modal_method_centered", _4 as "ok_button", _5 as "zIndex" }
